/* eslint-disable prefer-arrow-callback */
/**
 * CTA Popup functionality
 *
 * @package ppd
 * @since   1.0.0
 */

import $ from 'jquery';

let scrollY = '';
let scrolled = false;
let footerOffset;
let bottomPos;
$('.cta-anchor').click(function () {
	if ($(this).siblings('.cta-popup').length) {
		// When the modal is shown, we want a fixed body
		scrollY = $(window).scrollTop();
		scrollY = $('body').css('top', parseInt(scrollY) * -1);
		$('.cta-popup').toggleClass('visible');
		$('body').toggleClass('noscroll');
		return false;
	}
	return true;
});

$('.cta-popup--close').click(function () {
	$('.cta-popup').toggleClass('visible');
	$('body').toggleClass('noscroll');
	// When the modal is hidden...
	scrollY = $('body').css('top');
	scrollY = parseInt(scrollY) * -1;
	$('html, body').scrollTop(scrollY);
	return false;
});

$(window).scroll(function () {
	if (!scrolled) {
		scrolled = true;
		// setting up additional variables to avoid overlapping the footer
		footerOffset = $('footer').offset().top;
		bottomPos = $(this).scrollTop() + $(this).height();
		// if we would overlap the footer, we just need it to stop moving
		setTimeout(function () {
			if (bottomPos > footerOffset) {
				if ((bottomPos - 40) < footerOffset) {
					$('.cta-anchor').css(
						'bottom',
						'40px',
					);
					$('.cta-anchor').css(
						'position',
						'fixed',
					);
				} else {
					$('.cta-anchor').css(
						'bottom',
						0,
					);
					$('.cta-anchor').css(
						'position',
						'absolute',
					);
				}
			} else if ((bottomPos - 40) < footerOffset) {
				$('.cta-anchor').css(
					'bottom',
					'40px',
				);
				$('.cta-anchor').css(
					'position',
					'fixed',
				);
			}
			scrolled = false;
		}, 10);
	}
});
